var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"pa-2 ma-2",attrs:{"href":_vm.gear.link,"target":"_blank"}},[_c('v-img',{attrs:{"src":_vm.src,"height":"180px"}}),_vm._v(" "),_c('h5',{staticClass:"mt-2 font-weight-light"},[_vm._v(_vm._s(_vm.gear.name))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }